import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const Settings = lazy(() => import('Containers/Settings/Settings'));
const Notification = lazy(() => import('Containers/Notification/Notification'));

const routes = [
  {
    path: '/settings',
    exact: true,
    ContentComponent: Settings,
    Layout: MainLayout,
    name: 'Settings',
  },
  {
    path: '/notification',
    exact: true,
    ContentComponent: Notification,
    Layout: MainLayout,
    name: 'Notifications',
  },
];

export default routes;
